/**
 * Created by shubham on 24/4/18.
 */

import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../shared/services/http.service'
import { MdDialog,MdDialogRef } from '@angular/material';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import {TranslateService} from 'ng2-translate';

@Component({
    template: require('./user.component.html')
})

export class UserComponent {
    data: any = [];
    dialogRef;
    id: any;
    languageId: any;

    constructor(private router: Router, private route: ActivatedRoute, private httpService: HttpService,private sessionHandler:SessionHandler,
                public dialog: MdDialog,  private translate: TranslateService, private commonService: CommonService) {

        this.languageId = this.sessionHandler.getItem('languageId');
        if(!this.languageId){
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);

        this.commonService.userData.subscribe((value) => {
            this.data = value;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user/user.component.ts